module.exports = __webpack_public_path__ + "media/images/favicon/secondary/favicon-16x16-9acc9649cc85baa9c1ee6fdf297bfc60.png";